<template>
  <el-header class="header">
    <el-menu router class="el-menu" mode="horizontal" :default-active="pathname">
      <el-menu-item index="/" :route="{ name: 'Home' }">Панель управления</el-menu-item>
      <el-menu-item index="/report" :route="{ name: 'Report' }">Статистика</el-menu-item>
      <el-menu-item index="/dicts" :route="{ name: 'Dicts' }">Справочники</el-menu-item>
      <el-menu-item v-if="user.id_user_types && user.id_user_types >= 4" index="/admin" :route="{ name: 'Admin' }"
        >Админка</el-menu-item
      >
      <el-submenu index="/user" style="float: right">
        <template slot="title">
          <i class="el-icon-user"></i>
        </template>
        <el-menu-item @click="qrTlg">Telegram</el-menu-item>
        <el-menu-item index="Logout" @click="logout">Выход</el-menu-item>
      </el-submenu>
      <el-submenu v-if="user.id_user_types && user.id_user_types >= 4" index="Links" style="float: right">
        <template slot="title">Ссылки</template>
        <el-menu-item @click="toUrl('http://grafana.simple-check.ru')">Grafana</el-menu-item>
        <el-menu-item @click="toUrl('http://adminer.simple-check.ru')">Adminer</el-menu-item>
        <el-menu-item @click="toUrl('http://pgadmin.simple-check.ru')">pgAdmin</el-menu-item>
        <el-menu-item
          @click="toUrl('https://mcs.mail.ru/app/services/infra/servers/fae68b3c-9d15-4df4-89a9-fd47fe98fbd1/info/')"
          >Виртуальный сервер</el-menu-item
        >
        <el-menu-item @click="toUrl('https://github.com/orgs/simple-check/projects/1')">GitHub</el-menu-item>
      </el-submenu>
    </el-menu>
  </el-header>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({}),
  computed: {
    ...mapState(["user"]),
    pathname: () => window.location.pathname,
    testUser() {
      if (this.user.id_user_types && this.user.id_user_types >= 4) return true;
      if (this.user.id_clients == 8) return true;
      return false;
    },
  },
  async created() {
    console.log(window.location.pathname);
    //await this.$store.dispatch("updateUser");
  },
  methods: {
    toUrl(url) {
      window.open(url, "_blank");
    },
    logout() {
      window.localStorage.removeItem("token");
      window.location.href = "/login";
    },
    async qrTlg() {
      const qrRes = await this.$axios.get(`/api/auth/telegram`);
      this.$alert(
        `<img src="data:image/jpeg;base64,${qrRes.data.data.qr}" />Отсканируйте код на мобильном<br/>устройстве и перейдите по ссылке`,
        "",
        {
          dangerouslyUseHTMLString: true,
          center: true,
        }
      );
    },
  },
};
</script>
